import { createSelector } from '@reduxjs/toolkit';
import { getRangeValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectFloor = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('floor')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
